import { cn } from '@/lib/cn';
import * as React from 'react';

export interface RadioButtonProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  label?: string;
}

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, label, id, ...props }, ref) => {
    return (
      <label
        htmlFor={id}
        className={cn(
          'flex cursor-pointer items-center gap-2 text-sm',
          props.disabled && 'cursor-not-allowed opacity-50',
          className,
        )}
      >
        <input
          type="radio"
          id={id}
          ref={ref}
          className="border-input text-primary focus:ring-primary size-4 cursor-pointer border bg-transparent focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed"
          {...props}
        />
        {label && (
          <span className="text-table-foreground select-none">{label}</span>
        )}
      </label>
    );
  },
);
RadioButton.displayName = 'RadioButton';

export { RadioButton };
